import React from 'react';
import { ChartRendererSupabase } from './ChartRendererSupabase';

interface EVBarriersScatterChartProps {
  chartData: any;
  chartOptions: any;
}

const EVBarriersScatterChart: React.FC<EVBarriersScatterChartProps> = ({ chartData, chartOptions }) => {
  return (
    <ChartRendererSupabase
      chartData={chartData}
      chartOptions={chartOptions}
      height="450px"
    />
  );
};

export default EVBarriersScatterChart;
